import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { observer, useObserver } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { routeNode } from 'core/routing';

import { useRouterStore, useClientStore } from 'apps/hooks';
import { PlanMonitor } from 'apps/initiative/views/PlanMonitor';
import { FourOhFour } from 'apps/fourOhFour';
import FullScreenLoading from 'apps/share/blocks/fullScreenLoading';

const UploadMakePart = lazy(() => import('apps/makePart/views/uploadMakePart'));
const MakePartFromFile = lazy(() =>
  import('apps/makePart/views/makePartFromFile'),
);

const viewsMap = {
  '': UploadMakePart,
  file: MakePartFromFile,
};

const MakePartSpace = withNamespaces()(
  observer(props => {
    const { route, params, navigate } = useRouterStore();
    const clientStore = useClientStore();
    const { componentFromRoute } = props;

    const View = componentFromRoute();

    if (
      route.name === 'workspace.make-part' &&
      !clientStore.activeInitiativeSpace.subscriptionType === 'BUSINESS' &&
      !clientStore.hasRole('INTERMEDIATOR') &&
      CI === 'false'
    ) {
      navigate('workspace', {
        spacePath: clientStore.slugFromRouteOrSpace,
      });

      return null;
    }

    return useObserver(() => (
      <Suspense fallback={<FullScreenLoading />}>
        <PlanMonitor>
          <View params={params} routeName={route.name} />
        </PlanMonitor>
      </Suspense>
    ));
  }),
);

MakePartSpace.propTypes = {
  routerStore: PropTypes.object,
  clientStore: PropTypes.object,
};

const MakePartRouter = routeNode(
  'workspace.make-part',
  viewsMap,
  FourOhFour,
)(MakePartSpace);

export default MakePartRouter;
